(() => {
  const config = document.currentScript;
  const root = (config.dataset.root || '/').replace(/\/$/, '');
  const roots = JSON.parse(config.dataset.languageRoots || '[]')
    .map(value => value.replace(/\/$/, ''))
    .filter(Boolean)
    .sort((a, b) => b.length - a.length);
  const localize = link => {
    if (link.closest('.sa-language-switcher, localization-form, .localization-form')) return;
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;
    let url;
    try { url = new URL(href, location.href); } catch { return; }
    if (url.origin !== location.origin) return;
    let path = url.pathname;
    const languageRoot = roots.find(value => path === value || path.startsWith(value + '/'));
    if (languageRoot) path = path.slice(languageRoot.length) || '/';
    if (!/^\/(?:$|(?:pages|products|collections|blogs|search|cart|policies)(?:\/|$))/.test(path)) return;
    const destination = (root + path) + url.search + url.hash;
    if (url.pathname + url.search + url.hash !== destination) link.setAttribute('href', destination);
  };
  const scan = node => {
    if (!(node instanceof Element) && node !== document) return;
    if (node.matches?.('a[href]')) localize(node);
    node.querySelectorAll('a[href]').forEach(localize);
  };
  scan(document);
  new MutationObserver(records => records.forEach(record => {
    if (record.type === 'attributes') localize(record.target);
    else record.addedNodes.forEach(scan);
  })).observe(document.documentElement, {childList:true,subtree:true,attributes:true,attributeFilter:['href']});
})();
